import axios from 'axios'

const BASE_URL = process.env.VUE_APP_BASE_URL || ''

const request = axios.create({
  baseURL: BASE_URL,
  timeout: 10000
})

request.interceptors.response.use(
  (response) => {
    const body = response.data

    if (body && typeof body === 'object' && Object.prototype.hasOwnProperty.call(body, 'code')) {
      const isSuccess = body.code === 200 || body.code === '200' || body.code === 0 || body.code === '0'

      if (!isSuccess) {
        return Promise.reject(new Error(body.msg || body.message || '接口请求失败'))
      }
    }

    return body
  },
  (error) => Promise.reject(error)
)

export default request
